"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _lodash = _interopRequireDefault(require("lodash.groupby")),
    _lodash2 = _interopRequireDefault(require("lodash.orderby")),
    _ActivityItem = _interopRequireDefault(require("./ActivityItem"));

require("../styles/_history-tab.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var groupHistoryByDay = function groupHistoryByDay(history) {
  var groupedByDay = (0, _lodash["default"])(history, function (_ref) {
    var createdAt = _ref.createdAt;
    return (0, _moment["default"])(createdAt).startOf("day").format();
  }),
      groupedByDayArray = Object.entries(groupedByDay).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        dayDate = _ref3[0],
        activities = _ref3[1];

    return {
      dayDate: dayDate,
      activities: activities
    };
  });
  return (0, _lodash2["default"])(groupedByDayArray, "dayDate", ["desc"]);
},
    HistoryTab = function (_Component) {
  function HistoryTab() {
    var _this;

    return (0, _classCallCheck2["default"])(this, HistoryTab), _this = _super.call(this), _this.fetchHistory = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var getResourceHistory, _yield$getResourceHis, error, data;

      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              return getResourceHistory = _this.props.getResourceHistory, _context.next = 3, getResourceHistory();

            case 3:
              if (_yield$getResourceHis = _context.sent, error = _yield$getResourceHis.error, data = _yield$getResourceHis.data, !error) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _this.setState({
                history: groupHistoryByDay(data.getResourceHistory)
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.state = {
      history: []
    }, _this;
  }

  (0, _inherits2["default"])(HistoryTab, _Component);

  var _super = _createSuper(HistoryTab);

  return (0, _createClass2["default"])(HistoryTab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchHistory();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children,
          history = this.state.history;
      return _react["default"].createElement("div", {
        className: "history-tab"
      }, children, _react["default"].createElement("div", {
        className: "history-tab__list"
      }, history.map(function (_ref5) {
        var dayDate = _ref5.dayDate,
            activities = _ref5.activities;
        return [_react["default"].createElement("div", {
          key: dayDate,
          className: "history-tab__list__day-activities"
        }, _react["default"].createElement("div", {
          className: "history-tab__list__day-activities__date"
        }, (0, _moment["default"])(dayDate).calendar(null, {
          sameDay: "[TODAY]",
          lastDay: "[YESTERDAY]",
          sameElse: "MMM DD"
        })), activities.map(function (_ref6) {
          var id = _ref6.id,
              user = _ref6.user,
              logType = _ref6.logType,
              date = _ref6.createdAt;
          return _react["default"].createElement(_ActivityItem["default"], {
            key: id,
            user: user,
            action: logType,
            createdAt: date
          });
        }))];
      })));
    }
  }]), HistoryTab;
}(_react.Component);

exports["default"] = HistoryTab;